import React, { useState } from "react";
import TicketSummary from "../../components/Tickets/TicketSummary";
import TicketForm from "../../components/Tickets/TicketForm";
import { t } from "@lingui/macro";

const TicketPage = () => {
  const [ticketData, setTicketData] = useState(null);
  const [step, setStep] = useState(1); // Step 1: Ticket Form, Step 2: Ticket Summary (Payment)

  const handleTicketSubmit = (values) => {
    console.log("Form submitted with values:", values);

    const ticketOrderRequest = {
      email: values.email,
      isGroup: values.isGroup,
      paymentMethod: "stripe",
      total: values.total, 
      tickets: Object.values(values.tickets)
        .filter((ticket) => ticket.quantity > 0)
        .map((ticket) => ({
          priceId: ticket.priceId,
          priceCategory: ticket.priceCategory,
          quantity: ticket.quantity,
        })),
    };

    setTicketData(ticketOrderRequest);
    setStep(2); // Move to Step 2 (Ticket Summary)
  };

  const handleBackToTicketForm = () => {
    setTicketData(null); // Clear ticket data
    setStep(1); // Reset to Step 1 (Ticket Form)
  };

  return (
    <div className="ticket-page">
      <h1>{t`Buy Tickets`}</h1>
      <p>{t`Select your tickets and proceed with the purchase.`}</p>

      {step === 1 && !ticketData && <TicketForm onSubmit={handleTicketSubmit} />}
      {step === 2 && ticketData && (
        <TicketSummary
          ticketData={ticketData}
          onBack={handleBackToTicketForm}
        />
      )}
    </div>
  );
};

export default TicketPage;
